import { render } from "./HeroiconsSolidDotsHorizontal.vue?vue&type=template&id=2fdeea6b"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDotsHorizontal.vue"]])

export default __exports__